// extracted by mini-css-extract-plugin
export var danger = "_1u-6";
export var lightPink = "_1u-a";
export var medium = "_1u-j";
export var nearSquare = "_1u-m";
export var neutralBlue = "_1u-8";
export var neutralYellow = "_1u-7";
export var noCapitalize = "_1u-1";
export var normal = "_1u-2";
export var pill = "_1u-0";
export var primary = "_1u-3";
export var primaryLight = "_1u-4";
export var shadow = "_1u-n";
export var small = "_1u-k";
export var solidBlack = "_1u-i";
export var solidGreen = "_1u-d";
export var solidLightBlue = "_1u-f";
export var solidNavy = "_1u-e";
export var solidOrange = "_1u-h";
export var solidPink = "_1u-g";
export var solidRed = "_1u-b";
export var solidWhite = "_1u-9";
export var solidYellow = "_1u-c";
export var success = "_1u-5";
export var xsmall = "_1u-l";